var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.about)?_c('main',{staticClass:"imprint"},[_c('section',{staticClass:"col-2"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.about.imprint)}}),_c('div')])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }